<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-visita-item') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo" @click="redirectToList()">
                                        {{ $t('agro-visita') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('item') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $route.params.id ? iderp : $t('novo') }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <ul
                    class="nav nav-tabs nav-tabs-children"
                    v-if="isUpdate"
                    key="agro-visita-item-manage"
                >
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="permissao.read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">
                            <span v-if="aba.icone" class="icon" :style="{ color: aba.cor }">
                                <i :class="aba.icone.toLowerCase()" />
                            </span>
                            {{ $t(aba.descricao) }}
                        </a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown
                    aria-role="list"
                    class="mobile-tab-list"
                    key="agro-visita-item-manage-mobile"
                >
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            <span
                                v-if="abas[abaSelecionada].icone"
                                class="icon"
                                :style="{ color: abas[abaSelecionada].cor }"
                            >
                                <i :class="abas[abaSelecionada].icone.toLowerCase()" />
                            </span>
                            {{ $t(abas[abaSelecionada].descricao) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="permissao.read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        <span v-if="aba.icone" class="icon" :style="{ color: aba.cor }">
                            <i :class="aba.icone.toLowerCase()" />
                        </span>
                        {{ $t(aba.descricao) }}
                    </b-dropdown-item>
                </b-dropdown>
                <div class="aba-visitaitem">
                    <Geral
                        ref="tabGeral"
                        v-if="abasAbertas[0] && !newToEdit && permissao.read"
                        v-show="abas[abaSelecionada].id == 0"
                        :isUpdate="isUpdate"
                        :cantEdit="cantEdit"
                        :tabChanged="abas[abaSelecionada].id != 0"
                        @isChanged="isChanged = $event"
                        @redirectList="redirectToList"
                        @situacao="situacao = $event"
                        @open-modal-info-ocorrencia="openOcorrenciaDetalhes"
                        @set-selected-ocorrencia="setSelectedOcorrencia"
                        @set-has-produtos="ocorrenciaHasProdutos = $event"
                        @set-has-anexos="ocorrenciaHasAnexos = $event"
                        @iderp="iderp = $event"
                    />
                    <Recomendacao
                        ref="tabRecomendacao"
                        v-if="abasAbertas[1] && !newToEdit && permissao.read"
                        v-show="abas[abaSelecionada].id == 1"
                        :isUpdate="isUpdate"
                        :cantEdit="cantEdit"
                        :situacao="situacao"
                        :hasOcorrenciaSelecionada="ocorrenciaSelecionadaId > 0"
                        :ocorrenciaHasProdutos="ocorrenciaHasProdutos"
                        :ocorrenciaHasAnexos="ocorrenciaHasAnexos"
                        @isChanged="isChanged = $event"
                        @open-modal-info-ocorrencia="openOcorrenciaDetalhes"
                    />
                    <Foto
                        ref="tabFoto"
                        v-if="abasAbertas[2] && !newToEdit && permissao.read"
                        v-show="abas[abaSelecionada].id == 2"
                        :isUpdate="isUpdate"
                        :cantEdit="cantEdit"
                        :situacao="situacao"
                        :hasOcorrenciaSelecionada="ocorrenciaSelecionadaId > 0"
                        :ocorrenciaHasProdutos="ocorrenciaHasProdutos"
                        :ocorrenciaHasAnexos="ocorrenciaHasAnexos"
                        @isChanged="isChanged = $event"
                        @open-modal-info-ocorrencia="openOcorrenciaDetalhes"
                    />
                </div>
            </div>

            <!-- MODAL -->
            <b-modal
                class="modal-detalhes-ocorrencia"
                :active.sync="showModal"
                @fecharModal="fecharModal"
            >
                <div class="bg">
                    <DetalhesOcorrenciaModalManage
                        v-if="showModal"
                        :abaSelecionadaNome="abaSelecionadaNome"
                        :ocorrenciaId="+ocorrenciaSelecionadaId"
                        :ocorrenciaHasProdutos="ocorrenciaHasProdutos"
                        :ocorrenciaHasAnexos="ocorrenciaHasAnexos"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';
import TipoOcorrenciaService from '@/services/agro/ocorrencia/TipoOcorrenciaService';
// Modal
import DetalhesOcorrenciaModalManage from '@/components/agro/agro-visita-item/modal/DetalhesOcorrenciaModalManage';
// Abas
import Geral from '@/components/agro/agro-visita-item/abas/Geral';
import Recomendacao from '@/components/agro/agro-visita-item/abas/Recomendacao';
import Foto from '@/components/agro/agro-visita-item/abas/Foto';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'agro-visita-item-new' && to.name == 'agro-visita-item-edit') {
            this.isUpdate = true;

            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        Geral,
        Recomendacao,
        Foto,
        DetalhesOcorrenciaModalManage,
    },
    data() {
        return {
            tipoOcorrenciaService: new TipoOcorrenciaService(this.$http, this.$router),
            abaSelecionada: 0,
            abas: [
                {
                    id: 0,
                    descricao: 'dados-cadastrais',
                },
                {
                    id: 1,
                    descricao: 'recomendacao',
                },
                {
                    id: 2,
                    descricao: 'foto',
                },
            ],
            abasAbertas: {},
            tiposOcorrencias: [],
            ocorrenciaSelecionadaId: 0,
            abaSelecionadaNome: 'geral',
            ocorrenciaHasProdutos: false,
            ocorrenciaHasAnexos: false,
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            permissao: false,
            cantEdit: false,
            situacao: null,
            showModal: false,
            iderp: null,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        situacao(val) {
            if (val != 4) this.cantEdit = true;
        },
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-visita-item' },
            });
        } else {
            this.cantEdit =
                (!this.isUpdate && !this.permissao.create) ||
                (this.isUpdate && !this.permissao.update);

            this.abasAbertas[0] = true;
        }
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada].id] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        openOcorrenciaDetalhes(obj) {
            if (obj != null) {
                if (obj.ocorrenciaId && obj.ocorrenciaId > 0) {
                    this.ocorrenciaSelecionadaId = obj.ocorrenciaId;
                }
                this.abaSelecionadaNome = obj.buttonClicked;

                this.showModal = true;
            }
        },
        fecharModal() {
            this.showModal = false;
        },
        setSelectedOcorrencia(obj) {
            this.ocorrenciaSelecionadaId = obj;
        },
        redirectToList() {
            if (this.$route.query.tela) {
                let tempTela = null;
                let tempAba = null;
                let tempId = null;
                // if (this.$route.query.tela == "agro-cultura-edit") {
                //   tempAba = "ocorrencia";
                //   tempTela = this.$route.query.tela;
                //   tempId = this.$route.query["id"];
                // }
                if (tempTela != null) {
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: tempId },
                            query: { abaSelecionada: tempAba },
                        });
                    }, 1000);
                } else {
                    this.$router.push({
                        name: 'agro-visita-edit',
                        params: { id: this.$route.params.idvisita },
                    });
                }
            } else {
                this.$router.push({
                    name: 'agro-visita-edit',
                    params: { id: this.$route.params.idvisita },
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
.aba-visitaitem {
    height: 100%;
}
</style>
